import script from "./employee.vue?vue&type=script&setup=true&lang=ts"
export * from "./employee.vue?vue&type=script&setup=true&lang=ts"

import "./employee.vue?vue&type=style&index=0&id=480b6e4a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-480b6e4a"]])

export default __exports__